import fetcher, { mutateGraphQL } from '@/services/fetcher'
import { buildQueryV2 } from '@/utils/helpers'

const ADDRESS_TYPE = `query getDirectoryTypes {
  directoryTypes{
    type_code
    type_label
    fields {
      field_code
      field_label
    }
  }
}`

const SET_SHIPPING_METHOD = `
mutation setShippingAddress($inputSetShippingAddresses: SetShippingAddressesOnCartInput) {
    setShippingAddressesOnCart(input: $inputSetShippingAddresses) {
      cart {
        shipping_addresses {
          available_shipping_methods {
            amount {
              currency
              value
            }
            available
            carrier_code
            carrier_title
            error_message
            method_code
            method_title
          }
        }
      }
    }
  }
`
const fetchAddressType = async (options?: { locale?: string }) => {
  try {
    const response = await fetcher.get(buildQueryV2(ADDRESS_TYPE), {
      next: { revalidate: 300, tags: ['list-address-type'] },
      cache: 'force-cache',
      locale: options?.locale,
    })
    const listAddressTypes = response?.payload?.data?.directoryTypes as TAddressResponse[]
    return listAddressTypes
  } catch (err) {
    console.log(err)
    return undefined
  }
}

const setShippingAddressV2 = async (input: IShippingAddressPayloadV2) => {
  try {
    const response = await mutateGraphQL({
      query: SET_SHIPPING_METHOD,
      variables: input,
    })
    const data = response?.payload?.data?.setShippingAddressesOnCart as IShippingAddressOnCart
    return data
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export { fetchAddressType, setShippingAddressV2 }
